import React, { useEffect, useState, useContext } from "react"
import ActividadesProy from "./ActividadesProy"
import { bkSubMain, clBasic, codiguera, Sfiltros, Sfiltro, SinputFiltro, SetiquetaFiltro, borderSubMain } from "./general";
import { AppContext } from "./index";
import Story from "./Story"
import ListaOpciones from "./ListaOpciones"
import add from "./img/add.png";
import volver from "./img/ampliar.png";
import buscador from "./img/buscador.png";
import CRUDhistorias from "./CRUDhistorias";
import { useSpring, animated as a } from 'react-spring'

export default function Sprints() {
    let { firebase } = useContext(AppContext);
    const [stories, setStories] = useState([]);
    const [estado, setEstado] = useState("pendiente")
    const [tipo, setTipo] = useState("Todos")
    const [prioridad, setPrioridad] = useState("Todos")
    const [texto, setTexto] = useState("")
    const [refresh, setRefresh] = useState(true)

    const [flipped, set] = useState(false)
    const { transform, opacity } = useSpring({
        opacity: flipped ? 1 : 0,
        transform: ` rotateY(${flipped ? 360 : 0}deg)`,
        config: { mass: 9, tension: 800, friction: 140 }
    })

    useEffect(() => {
        setStories(firebase.stories(firebase.proyectoActivo.proyecto.id, estado, "Todos", prioridad, tipo, texto));
    }, [estado, prioridad, tipo, texto, flipped, firebase.dataStories], refresh);

    useEffect(() => {
        document.getElementById("htmlTituloPagS").innerHTML = "(Sprints)";
    }, []);

    return (
        < div style={Ssprints} >
            <div style={SstoriesCab}>
                <div style={Slabel}>
                    Historias de usuario
                </div>
                <div style={Sstories} >
                    <a.div style={{ ...ScaraLista, opacity: opacity.interpolate(o => 1 - o), transform, zIndex: flipped ? 1 : 4 }}>
                        <div style={Sfiltros} >
                            <div style={Sfiltro}>
                                <div style={SetiquetaFiltro} >Estado:</div>
                                <div id="SPestado" style={SinputFiltro} >
                                    {estado}
                                </div>
                            </div>
                            <div style={Sfiltro}>
                                <div style={SetiquetaFiltro} >Tipo:</div>
                                <div id="SPtipo" style={SinputFiltro} >
                                    {tipo}
                                </div>
                            </div>
                            <div style={Sfiltro}>
                                <div style={SetiquetaFiltro} >Prioridad:</div>
                                <div id="SPprioridad" style={SinputFiltro} >
                                    {prioridad}
                                </div>
                            </div>
                            <div style={Sfiltro}>
                                <img src={buscador} height="20px" width="20px" alt="?" style={{ margin: "7px" }} />
                                <input style={{ ...SinputFiltro, width: "7vw", border: bkSubMain }} type="text"
                                    value={texto}
                                    onChange={(e) => {
                                        e.persist();
                                        setTexto(e.target.value)
                                    }}>
                                </input>
                            </div>

                            <ListaOpciones setFiltro={setEstado} lista={codiguera["estadoHistoria"]} elemento="SPestado" titulo={"Estado"} absolute={1} />
                            <ListaOpciones setFiltro={setTipo} lista={codiguera["tipoHistoria"]} elemento="SPtipo" titulo={"Tipo"} absolute={1} />
                            <ListaOpciones setFiltro={setPrioridad} lista={codiguera["prioridad"]} elemento="SPprioridad" titulo={"Prioridad"} absolute={1} />
                        </div >
                        <div style={SlistaYboton}>
                            <div style={SmarcoLista}>
                                <div style={SlistaStories}>
                                    {stories.map(s => {
                                        return (
                                            <div style={Sstory} key={s.id}>
                                                <Story story={s} setRefresh={setRefresh} />
                                            </div>)
                                    }
                                    )}
                                </div>
                            </div>
                            <div style={Sadd}>
                                <img
                                    src={add}
                                    alt="+"
                                    title="Agregar"
                                    height="20px"
                                    width="20px"
                                    style={{ display: "block", cursor: "pointer", margin: "10px 0px 10px 10px" }}
                                    onClick={() => {
                                        set(flipped => !flipped)
                                    }}
                                ></img>
                            </div>
                        </div>
                    </a.div>
                    <a.div style={{ ...ScaraCrud, opacity, transform, zIndex: flipped ? 4 : 1 }}>
                        <div style={ScrudHistorias}>
                            <CRUDhistorias proyecto={firebase.proyectoActivo.proyecto.id} />
                        </div>
                        <div style={Sadd}>
                            <img
                                src={volver}
                                alt="+"
                                title="Agregar"
                                height="20px"
                                width="20px"
                                style={{ display: "block", cursor: "pointer", margin: "10px 0px 10px 10px" }}
                                onClick={() => {
                                    set(flipped => !flipped)
                                }}
                            ></img>
                        </div>
                    </a.div>
                </div>
            </div>

            <div style={Stimeline}>
                <ActividadesProy lmax={window.innerWidth * 0.23} ampliado={false} />
            </div>
        </div >
    )
}

const Ssprints = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    width: "93vw",
    height: "90vh",
}

const SstoriesCab = {
    width: "44%",
}

const Sstories = {
    width: "100%",
    margin: "10px 0px 20px 0px",
    position: "relative"
}

const ScaraLista = {
    width: "100%",
    position: "absolute",
}

const ScaraCrud = {
    width: "100%",
    position: "absolute",
    borderRadius: "10px",
    background: bkSubMain,
    border: `2px solid ${borderSubMain}`,
}

const Stimeline = {
    position: "relative",
    margin: "10px",
    width: "51%"
};

const Slabel = {
    fontSize: "2.7vh",
    fontWeight: 700,
    textAlign: "left",
    paddingLeft: "3vw",
    marginTop: "15px",
    color: clBasic,
};

const SlistaYboton = {
    height: "71vh",
    width: "100%",
    borderRadius: "10px",
    background: bkSubMain,
    border: `2px solid ${borderSubMain}`,
    marginTop: "10px"
}

const SmarcoLista = {
    overflowY: "auto",
    height: "66vh",
    width: "100%"
}

const SlistaStories = {
    display: "grid",
    gridTemplateColumns: "50% 50%",
    overflowY: "auto",
    maxHeight: "66vh",
    width: "100%"
}

const ScrudHistorias = {
    overflowY: "auto",
    height: "74vh",
    width: "100%"
}

const Sstory = {
    width: "100%",
}

const Sadd = {
    display: "flex",
    justifyContent: "flex-start",
};


